module.exports = __webpack_public_path__ + "static/media/48360191_2308772262531285_6949561757023076352_o-thumb.b3f17ee7.jpg";